import React, { useEffect, useMemo, useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { FormikProvider, Form, useFormik } from 'formik';
import AddCourseStepTwo from './AddCourseStepTwo';
import { useDispatch } from 'react-redux';
// import { getProjects } from '../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import FirstStepAddCourse from './FirstStepAddCourse';
import { stepOneSchema, stepTwoSchema } from './utils/validationSchema';
import {
  clearCourseState,
  getCourseDescription,
  postCourseDescription,
  putCourseDescription,
} from '../../../redux/features/courseSlice';
import Loader3D from '../../../components/Loader/Loader3D';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { TextField } from '@mui/material';

const AddCourse = ({ row, open, setOpen, successDispatchFn, successDispatchParams }) => {
  const [step, setStep] = useState(1);

  const dispatch = useDispatch();
  // const projectslistWithAll = useSelector((state) => state.refund.projectslist);
  const courseDescription = useSelector((state) => state.course.courseDescription.data?.[0] ?? {});
  const apiHandlerHelper = useHandleApiResponse();
  const loading = useSelector((state) => state.course.courseDescription.loading);

  /* const projectslist = useMemo(
    () => projectslistWithAll?.slice(1, projectslistWithAll?.length),

    [projectslistWithAll],
  ); */

  /*  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]); */

  const handleClose = () => {
    setOpen(false);
    setStep(1);
  };

  useEffect(() => {
    dispatch(
      clearCourseState({
        stateName: 'courseDescription',
        clearValue: {
          data: [],
          loading: false,
        },
      }),
    );
    row?.course_available_detail_id &&
      dispatch(getCourseDescription({ course_available_detail_id: row?.course_available_detail_id }));
  }, [row?.course_available_detail_id, dispatch]);

  const initialValues = {
    // project: row?.projectId ?? '',
    course_available_id: row?.id || row?.course_available_id || '',
    title: courseDescription?.title ?? '',
    courseType: courseDescription?.course_type ?? '',
    ageFrom: courseDescription?.age_from ?? 3,
    ageTo: courseDescription?.age_to ?? 18,
    duration: courseDescription?.duration ?? '',
    lessons: courseDescription?.lessons ?? '',
    language: courseDescription?.languages_ids ?? [],
    // language: courseDescription?.language ?? '',
    certificate: courseDescription?.certificate ?? false,
    testimonialVideoLink: courseDescription?.testimonial_video_link ?? '',
    brochureUrl: courseDescription?.brochure_url ? [courseDescription?.brochure_url] : [],
    brochureUrlDisplay: courseDescription?.brochure_url ? 'Brouchure Attachment' : '',
    courseBannerUrl: courseDescription?.course_banner_url ? [courseDescription?.course_banner_url] : [],
    courseBannerUrlDisplay: courseDescription?.course_banner_url ? 'Course Banner Attachment' : '',
    // titleImageUrl: '',
    // titleImageUrlDisplay: '',

    description: courseDescription?.description ?? '',
    highlights: courseDescription?.highlights ?? ['', ''],
    focusArea: courseDescription?.focus_area ?? '',
    minSessionPerWeek: courseDescription?.min_session_per_week ?? '',
    reasons: courseDescription?.reasons ?? ['', ''],
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: step === 1 ? stepOneSchema : stepTwoSchema,
    onSubmit: (values) => {
      const modifiedValues={
        ...values,
        courseBannerUrl: values.courseBannerUrl[0],
        brochureUrl: values.brochureUrl[0],
      }
      if (step === 1) setStep(2);
      else {
        dispatch(
          row?.course_available_detail_id
            ? putCourseDescription({ id: row?.course_available_detail_id, data: modifiedValues })
            : postCourseDescription(modifiedValues),
        ).then((res) => {
          apiHandlerHelper(res, {
            onSuccess: () => {
              handleClose();
              successDispatchFn && dispatch(successDispatchFn(successDispatchParams));
            },
          });
        });
      }
    },
  });

  console.log("fomik",formik);
  

  return (
    <GlobalDialog
      closeButton={true}
      open={open}
      setOpen={setOpen}
      title={row?.course_available_detail_id ? 'Edit Course' : 'Add Course'}
      maxWidth="md"
      fullWidth
      content={
        loading ? (
          <Loader3D />
        ) : (
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <TextField value={row?.courseName || row?.course_name} fullWidth disabled sx={{ mb: 2 }} />
              {step === 1 && (
                <FirstStepAddCourse
                  formik={formik}
                  handleClose={handleClose}
                  // projectslist={projectslist}
                  setStep={setStep}
                />
              )}
              {step === 2 && <AddCourseStepTwo onBack={() => setStep(1)} />}
            </Form>
          </FormikProvider>
        )
      }
    />
  );
};

export default React.memo(AddCourse);
